
// packages
import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Stack } from '@mui/material'
import { useMediaQuery } from '@mui/material';

// local
import { putExamToken } from '../helpers/requestExamToken';
import formatName from '../utilities/formatName';


const ExamTokenRequestModal = ({data, handleClose, refreshHook=null}) => {
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const isMobile = useMediaQuery("(max-width:600px)");
    
    const [receiveTokens, setReceiveTokens] = useState(null);
    
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // STYLES 
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '65vw',
        minWidth: '45vw',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
    }
    const mobileModalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '65vw',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
    }


    return (
        <Box sx={!isMobile ? (modalStyle) : (mobileModalStyle)}>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{fontWeight:600}}>
          Add Tokens?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, mb:2 }}>
          Please choose how many exam tokens you would like to give {formatName(data.firstName)}. (Negative values will remove tokens)
          </Typography>
          <Stack direction={'row'} sx={{}}>
            <TextField
              id='outlined-number'
              label='Add Tokens'
              type='number'
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              onChange={(e) => setReceiveTokens(e.target.value)}
              sx={{mt:1,mb:2}}
            ></TextField>
            <Button variant='contained' sx={{ml:2, mt:1, mb:2}}onClick={() => {
                putExamToken(receiveTokens, data.email);
                if (refreshHook) {
                  refreshHook();
                }
                handleClose();
            }}>Confirm</Button>
          </Stack>
        </Box>
    );
}

export default ExamTokenRequestModal;